require('../../../modules/es.array.slice');
var entryVirtual = require('../../../internals/entry-virtual');

module.exports = entryVirtual('Array').slice;



//////////////////
// WEBPACK FOOTER
// ./node_modules/core-js-pure/es/array/virtual/slice.js
// module id = 418
// module chunks = 0 1